import React, { useMemo } from 'react'
import PartnerWorkoutCategoryForm from './_form'

export default function PartnerWorkoutCategoryAdd (props) {
  const data = useMemo(() => ({ active: false }), [])
  return (
    <PartnerWorkoutCategoryForm data={data} {...props} />
  )
}